import React, { useState } from "react";
import { Form, Select, Icon } from "antd";
import { FormComponentProps } from "antd/lib/form";
import SuccessSvg from "../../images/success.svg";

interface Props extends FormComponentProps {}

const index = (props: Props) => {
  return (
    <div className="last">
      <img src={SuccessSvg} alt="" />
      <div className="result">配对成功！</div>
    </div>
  );
};

export default Form.create()(index);
